const homepage = {
  path: 'homepage',
  component: resolve => require(['../../../../components/pages/studentspace/homepage'], resolve)
}

export default homepage



// WEBPACK FOOTER //
// ./src/router/pages/studentspace/homepage/index.js